import React from 'react'

const FilterstatusDropdown = props => {
  const { dropdownheading, dropdownplaceholder, selectedValue, options, onChange, selectedStatus } = props

  return (
    <div style={{ width: '14rem' }}>
      <label>{dropdownheading}</label>

      <select
        className='form-select'
        aria-label='Default select example'
        onChange={e => onChange(e)}
        value={selectedValue}
        disabled={selectedStatus === 'draft'}
      >
        <option value='' disabled hidden>
          {dropdownplaceholder}
        </option>
        {options.map(({ value, label }, index) => (
          <option key={index} value={value} selected={selectedValue === value}>
            {label}
          </option>
        ))}
      </select>
    </div>
  )
}

export default FilterstatusDropdown
